import { isRunningInMetaOSHub } from "owa-config";
import { getConfig } from "owa-service/lib/config";
import type MailboxInfo from "owa-client-types/lib/MailboxInfo";
import type RequestOptions from "owa-service/lib/RequestOptions";
import type TokenResponse from "owa-service/lib/contract/TokenResponse";
import { getTokenFromPrefixedToken } from "owa-tokenprovider-utils";
import { getApplicationSettings } from "owa-application-settings";

export async function getUserToken(options?: RequestOptions, mailboxInfo?: MailboxInfo, requestId?: string): Promise<TokenResponse | undefined> {
    const svcConfig = getConfig();
    let token: string | undefined = undefined;
    
    // Get user token from metaOS hub
    if (isRunningInMetaOSHub()) {
        token = await svcConfig.getAuthToken?.(undefined, mailboxInfo, requestId);
    }
    else {
        //Get the token response if we're running in Native host and getAuthTokenResponse is available, otherwise fall back to getUserToken
        if (getApplicationSettings("PlatformType").isMonarch && svcConfig.getAuthTokenResponse) {
            const tokenResponse = await svcConfig.getAuthTokenResponse(options?.headers, mailboxInfo, requestId);
            if (tokenResponse?.AccessToken) {
                return tokenResponse;
            }
            return undefined;
        }
        
        token =
            svcConfig.getUserToken &&
                (await svcConfig.getUserToken(options?.headers, mailboxInfo, requestId));
    }
    
    // Extract and return the access token
    const accessToken = token ? getTokenFromPrefixedToken(token) : undefined;
    return accessToken ? { AccessToken: accessToken } : undefined;
}
